// The AI tools Steerly records activity under, keyed by a short stable id.
// Convex stores the key; every reader shows the same display name from here.

export const AI_TOOL_NAMES: Readonly<Record<string, string>> = Object.freeze({
  "claude-code": "Claude Code",
  codex: "Codex",
  "gemini-cli": "Gemini CLI",
  "cursor-agent": "Cursor",
  "copilot-cli": "GitHub Copilot",
  "grok-cli": "Grok",
  opencode: "opencode",
  // A gateway caller whose user-agent is not Claude Code's.
  "anthropic-sdk": "Anthropic API client",
});

// Steerly's terminal agent labels (CLI_COMMANDS in src/terminalEngine.js) and
// chat driver keys (src/chatDrivers/index.js) to tool keys. A shell ("Regular
// Terminal") and the test agent are not AI tools.
const STEERLY_AGENT_TOOLS: Readonly<Record<string, string>> = Object.freeze({
  "Claude Code": "claude-code",
  Codex: "codex",
  "Gemini CLI": "gemini-cli",
  Cursor: "cursor-agent",
  "GitHub Copilot": "copilot-cli",
  Grok: "grok-cli",
  opencode: "opencode",
  claude: "claude-code",
  codex: "codex",
  gemini: "gemini-cli",
  cursor: "cursor-agent",
  copilot: "copilot-cli",
  grok: "grok-cli",
});

// Tools whose model traffic the AI gateway can route today (Anthropic API).
const GATEWAY_ROUTABLE = new Set(["claude-code", "anthropic-sdk"]);

const TOOL_KEY_RE = /^[a-z0-9][a-z0-9-]{0,39}$/;

// The two lookups below read own keys only, so a name such as "constructor" (a
// valid tool key) never returns an Object.prototype member.
export function toolDisplayName(tool: string): string {
  return Object.prototype.hasOwnProperty.call(AI_TOOL_NAMES, tool) ? AI_TOOL_NAMES[tool] : tool;
}

export function toolForSteerlyAgent(agent: string): string | null {
  return Object.prototype.hasOwnProperty.call(STEERLY_AGENT_TOOLS, agent)
    ? STEERLY_AGENT_TOOLS[agent]
    : null;
}

export function isGatewayRoutableTool(tool: string): boolean {
  return GATEWAY_ROUTABLE.has(tool);
}

export function isToolKey(value: unknown): value is string {
  return typeof value === "string" && TOOL_KEY_RE.test(value);
}
